import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

export class ContentLanguageLabelModel implements IContentLanguageLabelModel {
    Id?: number;
    ContentLanguageId: number;
    Value: string;
    SortIndex?: number;

    constructor(contentLanguageId: any, value: string, sortIndex: number) {
        this.ContentLanguageId = contentLanguageId;
        this.Value = value;
        this.SortIndex = sortIndex;
    }
}
